export function resolveStoriesPlaybackPaused(
  isMinimumAdvanceLocked: boolean,
  isUserPaused: boolean
): boolean {
  return isMinimumAdvanceLocked || isUserPaused
}
